export const resources = {
  CognitiveInsightsSearch: '',
  SearchCompleted: ''
};
